import { z } from 'zod';

export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;

export const broadcastSchema = z.object({
  text_uz: z
    .string()
    .trim()
    .min(1, 'broadcast.form.errors.textRequired')
    .max(4000, 'broadcast.form.errors.tooLong'),
  text_ru: z.string().trim().max(4000, 'broadcast.form.errors.tooLong').optional(),
  text_en: z.string().trim().max(4000, 'broadcast.form.errors.tooLong').optional(),
  text_kk: z.string().trim().max(4000, 'broadcast.form.errors.tooLong').optional(),
  image: z
    .instanceof(File)
    .refine((f) => f.type.startsWith('image/'), 'broadcast.form.errors.imageType')
    .refine((f) => f.size <= MAX_IMAGE_BYTES, 'broadcast.form.errors.imageTooLarge')
    .optional(),
});

export type BroadcastFormValues = z.infer<typeof broadcastSchema>;
